
import { Language } from '../types';

/**
 * Multi-language translation object for the ¡RR3VERENT!A platform.
 */
export const translations = {
  EN: {
    meta: {
      title: '¡RR3VERENT!A - Storytelling'
    },
    nav: {
      home: 'HOME',
      services: 'SERVICES',
      directors: 'FILMMAKERS',
      contact: 'CONTACT'
    },
    hero: {
      weAre: 'WE ARE',
      irreverentia: '¡RR3VERENT!A',
      headlineStart: 'WE ARE A CREATIVE PRODUCTION HOUSE FUSING CINEMATIC CRAFT WITH ',
      headlineHighlight: 'CUTTING-EDGE GENERATIVE AI.',
      headline: 'WE ARE A CREATIVE PRODUCTION HOUSE FUSING CINEMATIC CRAFT WITH CUTTING-EDGE GENERATIVE AI.',
      tagline: 'Bridging the gap between human storytelling, traditional filmmaking standards, and synthetic workflows to produce fiction, series, and agile campaigns for global brands.',
      cta: 'FILMMAKERS',
      demoReel: 'DEMO REEL'
    },
    services: {
      cinema: {
        title: 'CINEMA & SERIES: RADICAL PRE-PRODUCTION',
        description: 'Artificial Intelligence is the accelerator of your vision. We free directors and producers from creative and logistical bottlenecks so the masterpiece is defined before a camera is even turned on.',
        items: [
          {
            title: 'UNLIMITED PRE-VISUALIZATION (PRE-VIZ)',
            desc: 'We convert scripts and moodboards into high-fidelity animatics and storyboards. Radical iteration to ensure production design is 100% as desired.'
          },
          {
            title: 'WORLD-BUILDING & ART DESIGN',
            desc: 'Generation of unique environments, costumes, and visual elements. We create coherent universes that allow you to see in "post-production" mode during "pre-production" stages.'
          },
          {
            title: 'PREDICTIVE SCRIPT ANALYSIS',
            desc: 'We automatically identify the most complex shots and logistical challenges, optimizing the shooting schedule and preventing pre-production errors.'
          },
          {
            title: 'CHARACTER MODELING (CASTING)',
            desc: 'We create preliminary avatars with specific character traits to define the exact look before starting the traditional casting process.'
          },
          {
            title: 'ASSET EXTRACTION (BREAKDOWN)',
            desc: 'Exhaustive mapping of scenic needs. We automatically catalog every prop, vehicle, character, and special effect present in the script. We transform text into technical inventory lists ready for budgeting, eliminating human error in resource detection.'
          },
          {
            title: 'HYBRID PIPELINES (AI + VFX)',
            desc: 'Advanced synchronization of artificial intelligence with traditional visual effects workflows. We connect synthetic generation tools and neural networks directly with standard post-production environments. We optimize the workflow from ingest to final render, drastically accelerating iteration times and reducing operational costs without compromising maximum cinematic quality.'
          }
        ]
      },
      ads: {
        title: 'ADVERTISING, BRANDS & AGENCIES: CONTENT AT THE SPEED OF CULTURE',
        description: 'Time is the most valuable asset in advertising. IRREVERENTIA gathers a collective of Filmmakers to produce, using new technologies, relevant content in hours or days.',
        items: [
          {
            title: 'IDEATION & RAPID PROTOTYPING',
            desc: 'We develop mock-up versions of entire campaigns in hours or days. Perfect for proofs of concept and client pitches.'
          },
          {
            title: 'ON-DEMAND CONTENT & ADAPTATION',
            desc: 'Rapid generation of multiple versions of the same ad for different audiences, platforms, or formats without reshoot costs.'
          },
          {
            title: 'HIGH-FIDELITY EXECUTION',
            desc: 'We connect your project with the most suitable Filmmaker, ensuring high-quality cinematic results ready for the brand.'
          }
        ]
      }
    },
    directors: {
      title: 'FILMMAKERS',
      selectedWorks: 'SELECTED WORKS',
      roles: {
        prompt: 'SENIOR PROMPT ENGINEER',
        arch: 'NEURAL VISUAL ARCHITECT',
        editor: 'SYNTHETIC EDITOR',
        composer: 'ALGORITHMIC COMPOSER',
        trainer: 'MODEL TRAINER'
      },
      bios: {
        alex: 'Masters the language of machines better than human. Creates entire worlds with a single line of code.',
        sarah: 'Specialist in Veo style and video generation. Transforms static noise into masterpieces.',
        david: 'The all-seeing eye. Cuts frames at the speed of light using predictive algorithms.',
        maria: 'Generates frequencies that manipulate human emotions. Expert in AudioLM and sonic landscapes.',
        james: 'Teaches AI to dream beautiful nightmares. Curator of forbidden datasets.'
      }
    },
    about: {
      title: 'WE ARE IRREVERENT',
      subtitle: 'BUT GOOD PEOPLE! :)',
      epSpain: 'SPAIN',
      epMexico: 'MEXICO',
      intro1: "We are not 'serial prompters'. We are a team that believes in and vindicates human creativity above any artificial intelligence.",
      intro2: "And yes, we also use AI tools to expand ideas, universes, and stories.",
      list: [
        'UNLIMITED PRE-VISUALIZATION (PRE-VIZ)',
        'WORLD-BUILDING & ART DESIGN',
        'HYPER-REAL VISUALIZATION',
        'ON-DEMAND CONTENT & ADAPTATION',
        'HYBRID PIPELINES (AI + VFX)'
      ],
      contact: {
        title: 'CONTACT US',
        name: 'NAME',
        email: 'EMAIL',
        message: 'BRIEF / MESSAGE',
        send: 'SEND MESSAGE',
        phone: 'PHONE',
        social: 'NETWORKS'
      }
    },
    marquee: '/// HUMAN CREATIVITY /// STORYTELLING /// GENERATIVE AI /// PURE IRREVERENCE'
  },
  ES: {
    meta: {
      title: 'Storytelling disruptivo potenciado por IA.'
    },
    nav: {
      home: 'INICIO',
      services: 'SERVICIOS',
      directors: 'DIRECTORES',
      contact: 'CONTACTO'
    },
    hero: {
      weAre: 'SOMOS',
      irreverentia: '¡RR3VERENT!A',
      headlineStart: 'SOMOS UNA PRODUCTORA CREATIVA QUE UNE EL OFICIO CINEMATOGRÁFICO CON LA ',
      headlineHighlight: 'VANGUARDIA DE LA IA.',
      headline: 'SOMOS UNA PRODUCTORA CREATIVA QUE UNE EL OFICIO CINEMATOGRÁFICO CON LA VANGUARDIA DE LA IA.',
      tagline: 'El puente directo entre la narrativa humana tradicional y los flujos sintéticos más avanzados para acelerar la ficción, el cine y la publicidad de marcas globales.',
      cta: 'FILMMAKERS',
      demoReel: 'DEMO REEL'
    },
    services: {
      cinema: {
        title: 'CINE Y SERIES: PRE-PRODUCCIÓN RADICAL',
        description: 'La Inteligencia Artificial es el acelerador de su visión. Liberamos a directores y productores de los cuellos de botella creativos y logísticos para que la obra maestra se defina antes de encender una cámara.',
        items: [
          {
            title: 'PRE-VISUALIZACIÓN ILIMITADA (PRE-VIZ)',
            desc: 'Convertimos guiones y moodboards en animatics y storyboards de alta fidelidad. Iteración radical para garantizar que el diseño de producción es 100% el deseado.'
          },
          {
            title: 'WORLD-BUILDING & DISEÑO DE ARTE',
            desc: 'Generación de entornos, vestuarios y elementos visuales únicos. Creamos universos coherentes que te permiten ver en modo \'postproducción\' en instancias de \'pre-producción\'.'
          },
          {
            title: 'ANÁLISIS PREDICTIVO DE GUION',
            desc: 'Identificamos automáticamente los planos más complejos y los desafíos logísticos, optimizando el calendario de rodaje y evitando errores de pre-producción.'
          },
          {
            title: 'MODELADO DE PERSONAJES (CASTING)',
            desc: 'Creamos avatares preliminares con los rasgos específicos de los personajes para definir el look exacto antes de iniciar el proceso de casting tradicional.'
          },
          {
            title: 'EXTRACCIÓN DE ACTIVOS (BREAKDOWN)',
            desc: 'Mapeo exhaustivo de necesidades escénicas. Catalogamos automáticamente cada prop, vehículo, personaje y efecto especial presente en el guion. Transformamos el texto en listas de inventario técnicas y listas para presupuestar, eliminando el margen de error humano en la detección de recursos.'
          },
          {
            title: 'PIPELINES HÍBRIDOS (IA + VFX)',
            desc: 'Sincronización avanzada de inteligencia artificial con flujos de trabajo tradicionales de efectos visuales. Conectamos herramientas de generación sintética y redes neuronales directamente con entornos de postproducción estándar. Optimizamos el flujo de trabajo desde la ingesta hasta el render final, acelerando drásticamente los tiempos de iteración y reduciendo costes operativos sin comprometer la máxima calidad cinematográfica.'
          }
        ]
      },
      ads: {
        title: 'PUBLICIDAD, MARCAS Y AGENCIAS: CONTENIDO A LA VELOCIDAD DE LA CULTURA',
        description: 'El tiempo es el activo más valioso en la publicidad. ¡RR3VERENT!A reúne un colectivo de Filmmakers para producir, utilizando las nuevas tecnologías, contenido relevante en horas o días.',
        items: [
          {
            title: 'IDEACIÓN Y PROTOTIPADO RÁPIDO',
            desc: 'Desarrollamos versiones mock-up de campañas enteras en horas o días. Perfecto para pruebas de concepto y presentaciones de clientes.'
          },
          {
            title: 'CONTENIDO ON-DEMAND Y ADAPTACIÓN',
            desc: 'Generación rápida de múltiples versiones de un mismo anuncio para diferentes audiencias, plataformas o formatos sin costes de regrabación.'
          },
          {
            title: 'EJECUCIÓN DE ALTA FIDELIDAD',
            desc: 'Conectamos tu proyecto con el Filmmaker más adecuado, asegurando resultados cinematográficos de alta calidad, listos para la marca.'
          }
        ]
      }
    },
    directors: {
      title: 'FILMMAKERS',
      selectedWorks: 'TRABAJOS SELECCIONADOS',
      roles: {
        prompt: 'PROMPT ENGINEER SENIOR',
        arch: 'ARQUITECTA VISUAL NEURAL',
        editor: 'EDITOR SINTÉTICO',
        composer: 'COMPOSITORA ALGORÍTMICA',
        trainer: 'ENTRENADOR DE MODELOS'
      },
      bios: {
        alex: 'Domina el lenguaje de las máquinas mejor que el humano. Crea mundos enteros con una sola línea de código.',
        sarah: 'Especialista en estilo Veo y generación de video. Transforma el ruido estático en obras maestras.',
        david: 'El ojo que todo lo ve. Corta fotogramas a la velocidad de la luz usando algoritmos predictivos.',
        maria: 'Genera frecuencias que manipulan emociones humanas. Experta en AudioLM y paisajes sonoros.',
        james: 'Enseña a la IA a soñar pesadillas hermosas. Curador de datasets prohibidos.'
      }
    },
    about: {
      title: 'SOMOS IRREVERENTES',
      subtitle: 'PERO BUENA GENTE! :)',
      epSpain: 'ESPAÑA',
      epMexico: 'MÉXICO',
      intro1: "No somos 'serial prompters'. Somos un equipo que cree y reivindica la creatividad humana por sobre cualquier inteligencia artificial.",
      intro2: "Y sí, también nos valemos de herramientas de IA para expandir ideas, universos e historias.",
      list: [
        'PRE-VISUALIZACIÓN ILIMITADA (PRE-VIZ)',
        'WORLD-BUILDING & DISEÑO DE ARTE',
        'VISUALIZACIÓN HIPER-REAL',
        'CONTENIDO ON-DEMAND Y ADAPTACIÓN',
        'PIPELINES HÍBRIDOS (IA + VFX)'
      ],
      contact: {
        title: 'CONTÁCTANOS',
        name: 'NOMBRE',
        email: 'EMAIL',
        message: 'BRIEF / MENSAJE',
        send: 'ENVIAR MENSAJE',
        phone: 'TELÉFONO',
        social: 'REDES'
      }
    },
    marquee: '/// CREATIVIDAD HUMANA /// STORYTELLING /// IA GENERATIVA /// IRREVERENCIA PURA'
  },
  PT: {
    meta: {
      title: '¡RR3VERENT!A - Storytelling'
    },
    nav: {
      home: 'INÍCIO',
      services: 'SERVIÇOS',
      directors: 'CINEASTAS',
      contact: 'CONTATO'
    },
    hero: {
      weAre: 'SOMOS',
      irreverentia: '¡RR3VERENT!A',
      headlineStart: 'SOMOS UMA PRODUTORA CRIATIVA QUE UNE O OFÍCIO CINEMATOGRÁFICO À ',
      headlineHighlight: 'VANGUARDA DA IA.',
      headline: 'SOMOS UMA PRODUTORA CRIATIVA QUE UNE O OFÍCIO CINEMATOGRÁFICO À VANGUARDA DA IA.',
      tagline: 'A ponte direta entre a narrativa humana tradicional e os fluxos sintéticos mais avançados para acelerar a ficção, o cinema e a publicidade de marcas globais.',
      cta: 'FILMMAKERS',
      demoReel: 'DEMO REEL'
    },
    services: {
      cinema: {
        title: 'CINEMA E SÉRIES: PRÉ-PRODUÇÃO RADICAL',
        description: 'A Inteligência Artificial é o acelerador da sua visão. Libertamos diretores e produtores de gargalos criativos e logísticos para que a obra-prima seja definida antes mesmo de ligar uma câmera.',
        items: [
          {
            title: 'PRÉ-VISUALIZAÇÃO ILIMITADA (PRE-VIZ)',
            desc: 'Convertemos roteiros e moodboards em animatics e storyboards de alta fidelidad. Iteração radical para garantir que o design de produção seja 100% o desejado.'
          },
          {
            title: 'WORLD-BUILDING & DESIGN DE ARTE',
            desc: 'Geração de ambientes, figurinos e elementos visuais únicos. Criamos universos coherentes que permitem ver no modo "pós-produção" durante as fases de "pré-produção".'
          },
          {
            title: 'ANÁLISIS PREDITIVA DE ROTEIRO',
            desc: 'Identificamos automaticamente as cenas más complexas e desafios logísticos, optimizando o cronograma de filmagem e evitando erros de pré-produção.'
          },
          {
            title: 'MODELAGEM DE PERSONAGENS (CASTING)',
            desc: 'Criamos avatares preliminares com traços específicos dos personagens para definir o visual exato antes de iniciar o processo de casting tradicional.'
          },
          {
            title: 'EXTRAÇÃO DE ATIVOS (BREAKDOWN)',
            desc: 'Mapeamento exaustivo de necessidades cênicas. Catalogamos automaticamente cada prop, veículo, personagem e efeito especial presente no roteiro. Transformamos o texto em listas de inventário técnicas e prontas para orçamentar, eliminando a margem de erro humano na detecção de recursos.'
          },
          {
            title: 'PIPELINES HÍBRIDOS (IA + VFX)',
            desc: 'Sincronização avançada de inteligência artificial com fluxos de trabalho tradicionais de efeitos visuais. Conectamos ferramentas de geração sintética e redes neurais diretamente com ambientes de pós-produção padrão. Otimizamos o fluxo de trabalho desde a ingestão até o render final, acelerando drasticamente os tempos de iteração e reduzindo custos operacionais sem comprometer a máxima qualidade cinematográfica.'
          }
        ]
      },
      ads: {
        title: 'PUBLICIDADE, MARCAS E AGÊNCIAS: CONTEÚDO À VELOCIDADE DA CULTURA',
        description: 'O tempo é o ativo mais valioso na publicidade. IRREVERENTIA mobiliza um coletivo de Filmmakers para produzir, utilizando novas tecnologias, conteúdo relevante em horas ou dias.',
        items: [
          {
            title: 'IDEAÇÃO E PROTOTIPAGEM RÁPIDA',
            desc: 'Desenvolvemos versões mock-up de campanhas inteiras em horas ou dias. Perfeito para provas de conceito e apresentações a clientes.'
          },
          {
            title: 'CONTEÚDO ON-DEMAND E ADAPTAÇÃO',
            desc: 'Geração rápida de múltiplas versões do mesmo anúncio para diferentes públicos, plataformas ou formatos sem custos de refilmagem.'
          },
          {
            title: 'EXECUÇÃO DE ALTA FIDELIDADE',
            desc: 'Conectamos seu projeto ao Filmmaker mais adecuado, garantindo resultados cinematográficos de alta qualidade, prontos para a marca.'
          }
        ]
      }
    },
    directors: {
      title: 'FILMMAKERS',
      selectedWorks: 'TRABALHOS SELECIONADOS',
      roles: {
        prompt: 'ENGENHEIRO DE PROMPT SÊNIOR',
        arch: 'ARQUITETA VISUAL NEURAL',
        editor: 'EDITOR SINTÉTICO',
        composer: 'COMPOSITORA ALGORÍTMICA',
        trainer: 'TREINADOR DE MODELOS'
      },
      bios: {
        alex: 'Domina a linguagem das máquinas melhor que o humano. Cria mundos inteiros com uma linha de código.',
        sarah: 'Especialista em estilo Veo e geração de vídeo. Transforma ruído estático em obras-primas.',
        david: 'O olho que tudo vê. Corta quadros na velocidade da luz usando algoritmos preditivos.',
        maria: 'Gera frequências que manipulam emoções humanas. Especialista em AudioLM e paisagens sonoras.',
        james: 'Ensina a IA a soñar belos pesadelos. Curador de datasets proibidos.'
      }
    },
    about: {
      title: 'SOMOS IRREVERENTES',
      subtitle: 'MAS GENTE BOA! :)',
      epSpain: 'ESPANHA',
      epMexico: 'MÉXICO',
      intro1: "Não somos 'serial prompters'. Somos uma equipe que acredita e reivindica a criatividade humana acima de qualquer inteligência artificial.",
      intro2: "E sim, também usamos ferramentas de IA para expandir ideias, universos e histórias.",
      list: [
        'PRÉ-VISUALIZAÇÃO ILIMITADA (PRE-VIZ)',
        'WORLD-BUILDING & DESIGN ARTE',
        'VISUALIZAÇÃO HIPER-REAL',
        'CONTEÚDO ON-DEMAND E ADAPTAÇÃO',
        'PIPELINES HÍBRIDOS (IA + VFX)'
      ],
      contact: {
        title: 'CONTATE-NOS',
        name: 'NOME',
        email: 'EMAIL',
        message: 'BRIEF / MENSAGEM',
        send: 'ENVIAR MENSAGEM',
        phone: 'TELEFONE',
        social: 'REDES'
      }
    },
    marquee: '/// CRIATIVIDADE HUMANA /// STORYTELLING /// IA GENERATIVA /// IRREVERÊNCIA PURA'
  },
  FR: {
    meta: {
      title: '¡RR3VERENT!A - Storytelling'
    },
    nav: {
      home: 'ACCUEIL',
      services: 'SERVICES',
      directors: 'RÉALISATEURS',
      contact: 'CONTACT'
    },
    hero: {
      weAre: 'NOUS SOMMES',
      irreverentia: '¡RR3VERENT!A',
      headlineStart: 'NOUS SOMMES UNE SOCIÉTÉ DE PRODUCTION CRÉATIVE ALLIANT MÉTIER CINÉMATOGRAPHIQUE ET ',
      headlineHighlight: 'IA D\'AVANT-GARDE.',
      headline: 'NOUS SOMMES UNE SOCIÉTÉ DE PRODUCTION CRÉATIVE ALLIANT MÉTIER CINÉMATOGRAPHIQUE ET IA D\'AVANT-GARDE.',
      tagline: 'La passerelle directe entre la narration humaine traditionnelle et les flux de travail synthétiques pour accélérer la fiction, le cinéma et la publicité de marcas mondiales.',
      cta: 'FILMMAKERS',
      demoReel: 'DEMO REEL'
    },
    services: {
      cinema: {
        title: 'CINÉMA ET SÉRIES : PRÉ-PRODUCTION RADICALE',
        description: 'L\'Intelligence Artificielle est l\'accélérateur de votre vision. Nous libérons réalisateurs et producteurs des goulots d\'étranglement créatifs et logistiques pour que le chef-d\'œuvre soit défini avant même d\'allumer une caméra.',
        items: [
          {
            title: 'PRÉ-VISUALISATION ILLIMITÉE (PRE-VIZ)',
            desc: 'Nous convertissons scénarios et moodboards en animatiques et storyboards haute fidélité. Itération radicale pour garantir un design de production 100% conforme.'
          },
          {
            title: 'WORLD-BUILDING & DESIGN ARTISTIQUE',
            desc: 'Génération d\'environnements, costumes et éléments visuels uniques. Nous créons des univers cohérents qui vous permettent de voir en mode "post-production" lors des phases de "pré-production".'
          },
          {
            title: 'ANALYSE PRÉDICTIVE DE SCÉNARIO',
            desc: 'Nous identifions automatiquement les plans les plus complexes et les défis logistiques, optimisant le calendrier de tournage et évitant les erreurs de pré-production.'
          },
          {
            title: 'MODÉLISATION DE PERSONNAGES (CASTING)',
            desc: 'Nous créons des avatars préliminaire avec des traits spécifiques pour définir le look exact avant de commencer le processus de casting traditionnel.'
          },
          {
            title: 'EXTRACTION D\'ACTIFS (BREAKDOWN)',
            desc: 'Cartographie exhaustive des besoins scéniques. Nous cataloguons automatiquement chaque accessoire, véhicule, personnage et effet spécial présent dans le scénario. Nous transformons le texte en listes d\'inventaire techniques prêtes pour le budget, éliminant la marge d\'erreur humaine dans la détection des ressources.'
          },
          {
            title: 'PIPELINES HYBRIDES (IA + VFX)',
            desc: 'Synchronisation avancée de l\'intelligence artificielle avec les flux de travail traditionnels d\'effets visuels. Nous connectons les outils de génération synthétique et les réseaux neuronaux directement aux environnements de post-production standard. Nous optimisons le flux de travail, de l\'ingestion au rendu final, en accélérant considérablement les temps d\'itération et en réduisant les coûts opérationnels sans compromis sur la qualité cinématographique.'
          }
        ]
      },
      ads: {
        title: 'PUBLICITÉ, MARQUES ET AGENCES : CONTENU À la VITESSE DE LA CULTURE',
        description: 'Le temps est l\'actif le plus précieux dans la publicité. IRREVERENTIA mobilise un collectif de Filmmakers pour produire, à l\'aide de nouvelles technologies, du contenu pertinent en quelques heures ou jours.',
        items: [
          {
            title: 'IDÉATION ET PROTOTYPAGE RAPIDE',
            desc: 'Nous développons des versions maquettes de campagnes entières en quelques heures ou jours. Parfait pour les preuves de concept.'
          },
          {
            title: 'CONTENU À LA DEMANDE ET ADAPTATION',
            desc: 'Génération rapide de multiples versions d\'une même publicité pour différentes audiences ou formats sans coûts de nouveau tournage.'
          },
          {
            title: 'EXÉCUTION HAUTE FIDÉLITÉ',
            desc: 'Nous connectons votre projet avec le Filmmaker le plus adapté, garantissant des résultats cinématográficos de haute qualité, prêts pour la marque.'
          }
        ]
      }
    },
    directors: {
      title: 'FILMMAKERS',
      selectedWorks: 'ŒUVRES SÉLECTIONNÉES',
      roles: {
        prompt: 'INGÉNIEUR PROMPT SÉNIOR',
        arch: 'ARCHITECTE VISUELLE NEURALE',
        editor: 'ÉDITEUR SYNTHÉTIQUE',
        composer: 'COMPOSITRICE ALGORITHMIQUE',
        trainer: 'ENTRAÎNEUR DE MODÈLES'
      },
      bios: {
        alex: 'Maîtrise le langage des machines mieux que l\'humain. Crée des mondes entiers avec une ligne de code.',
        sarah: 'Spécialiste du style Veo et de la génération vidéo. Transforme le bruit statique en chefs-d\'œuvre.',
        david: 'L\'œil qui voit tout. Coupe les images à la vitesse de la lumière grâce à des algorithmes prédictifs.',
        maria: 'Génère des fréquences qui manipulent les émotions humaines. Experte en AudioLM.',
        james: 'Apprend à l\'IA à rêver de beaux cauchemars. Conservateur de datasets interdits.'
      }
    },
    about: {
      title: 'NOUS SOMMES IRRÉVÉRENCIEUX',
      subtitle: 'MAIS DES GENS BIENS ! :)',
      epSpain: 'ESPAGNE',
      epMexico: 'MEXIQUE',
      intro1: "Nous ne sommes pas des 'serial prompters'. Nous sommes une équipe qui croit et revendique la créativité humaine au-dessus de toute intelligence artificielle.",
      intro2: "Et oui, nous utilisons aussi des outils d'IA pour étendre les idées, les univers et les histoires.",
      list: [
        'PRÉ-VISUALISATION ILLIMITÉE (PRE-VIZ)',
        'WORLD-BUILDING & DESIGN ARTISTIQUE',
        'VISUALISATION HYPER-RÉALISTE',
        'CONTENU À LA DEMANDE ET ADAPTATION',
        'PIPELINES HYBRIDES (IA + VFX)'
      ],
      contact: {
        title: 'CONTACTEZ-NOUS',
        name: 'NOM',
        email: 'EMAIL',
        message: 'BRIEF / MESSAGE',
        send: 'ENVIAR LE MESSAGE',
        phone: 'TÉLÉPHONE',
        social: 'RÉSEAUX'
      }
    },
    marquee: '/// CRÉATIVITÉ HUMAINE /// STORYTELLING /// IA GÉNÉRATIVE /// IRRÉVÉRENCE PURE'
  },
  DE: {
    meta: {
      title: '¡RR3VERENT!A - Storytelling'
    },
    nav: {
      home: 'START',
      services: 'SERVICES',
      directors: 'REGISSEURE',
      contact: 'KONTAKT'
    },
    hero: {
      weAre: 'WIR SIND',
      irreverentia: '¡RR3VERENT!A',
      headlineStart: 'WIR SIND EINE KREATIVE PRODUKTIONSFIRMA, DIE FILMISCHES HANDWERK MIT ',
      headlineHighlight: 'SPITZEN-KI VEREINT.',
      headline: 'WIR SIND EINE KREATIVE PRODUKTIONSFIRMA, DIE FILMISCHES HANDWERK MIT SPITZEN-KI VEREINT.',
      tagline: 'Die direkte Brücke zwischen traditionellem menschlichem Storytelling und modernsten synthetischen Workflows für Kinofilm, Serien und agile Markenkampagnen.',
      cta: 'FILMMAKERS',
      demoReel: 'DEMO REEL'
    },
    services: {
      cinema: {
        title: 'FILM UND SERIEN: RADIKALE VORPRODUKTION',
        description: 'Künstliche Intelligenz ist der Beschleuniger Ihrer Vision. Wir befreien Regisseure und Produzenten von kreativen und logistischen Engpässen, damit das Meisterwerk definiert ist, bevor eine Kamera läuft.',
        items: [
          {
            title: 'GRENZENLOSE PRE-VISUALISIERUNG (PRE-VIZ)',
            desc: 'Wir konvertieren Drehbücher und Moodboards in High-Fidelity-Animatics and Storyboards. Radikale Iteration, um sicherzustellen, dass das Produktionsdesign zu 100% stimmt.'
          },
          {
            title: 'WORLD-BUILDING & KUNSTDESIGN',
            desc: 'Generierung einzigartiger Umgebungen, Kostüme und visueller Elemente. Wir schaffen kohärente Universen, mit denen Sie während der Vorproduktion im "Postproduktionsmodus" sehen können.'
          },
          {
            title: 'PRÄDIKTIVE DREHBUCHANALYSE',
            desc: 'Wir identifizieren automatisch die komplexesten Einstellungen und logistischen Herausforderungen, optimieren den Drehplan und vermeiden Fehler in der Vorproduktion.'
          },
          {
            title: 'CHARAKTERMODELLIERUNG (CASTING)',
            desc: 'Wir erstellen vorläufige Avatare mit spezifischen Merkmalen, um den genauen Look zu definieren, bevor der traditionelle Casting-Prozess beginnt.'
          },
          {
            title: 'ASSET-EXTRAKTION (BREAKDOWN)',
            desc: 'Erschöpfende Kartierung szenischer Bedürfnisse. Wir katalogisieren automatisch jede Requisite, jedes Fahrzeug, jeden Charakter und jeden Spezialeffekt im Drehbuch. Wir transformieren den Text in technische Inventarlisten für die Budgetplanung und eliminieren menschliche Fehler bei der Ressourcenerkennung.'
          },
          {
            title: 'HYBRIDE PIPELINES (KI + VFX)',
            desc: 'Fortschrittliche Synchronisierung von künstlicher Intelligenz mit traditionellen Visual-Effects-Workflows. Wir verbinden synthetische Generierungswerkzeuge und neuronale Netze direkt mit Standard-Postproduktionsumgebungen. Wir optimieren den Workflow vom Ingest bis zum finalen Rendering, beschleunigen die Iterationszeiten drastisch und senken die Betriebskosten, ohne die höchste filmische Qualität zu beeinträchtigen.'
          }
        ]
      },
      ads: {
        title: 'WERBUNG, MARKEN UND AGENTUREN: INHALT IN DER GESCHWINDIGKEIT DER KULTUR',
        description: 'Zeit ist das wertvollste Gut in der Werbung. IRREVERENTIA mobilisiert ein Kollektiv von Filmemachern, um mithilfe neuer Technologien relevante Inhalte in Stunden oder Tagen zu produzieren.',
        items: [
          {
            title: 'IDEENFINDUNG & SCHNELLES PROTOTYPING',
            desc: 'Wir entwickeln Mock-up-Versionen ganzer Kampagnen in Stunden oder Tagen. Perfekt für Proof-of-Concepts and Kundenpräsentationen.'
          },
          {
            title: 'ON-DEMAND-INHALTE & ANPASSUNG',
            desc: 'Schnelle Generierung mehrerer Versionen derselben Anzeige für verschiedene Zielgruppen oder Formate ohne Nachdrehkosten.'
          },
          {
            title: 'HIGH-FIDELITY-AUSFÜHRUNG',
            desc: 'Wir verbinden Ihr Projekt mit dem geeignetsten Filmemacher und garantieren hochwertige Ergebnisse.'
          }
        ]
      }
    },
    directors: {
      title: 'FILMMAKERS',
      selectedWorks: 'AUSGEWÄHLTE WERKE',
      roles: {
        prompt: 'SENIOR PROMPT ENGINEER',
        arch: 'NEURALE VISUELLE ARCHITEKTIN',
        editor: 'SYNTHETISCHER EDITOR',
        composer: 'ALGORITHMISCHE KOMPONISTIN',
        trainer: 'MODELL-TRAINER'
      },
      bios: {
        alex: 'Beherrscht die Sprache der Maschinen besser als Menschen. Erschafft Welten mit einer Codezeile.',
        sarah: 'Spezialistin für Veo-Stil und Videogenerierung. Verwandelt statisches Rauschen in Meisterwerke.',
        david: 'Das allsehende Auge. Schneidet Bilder in Lichtgeschwindigkeit mit prädiktiven Algorithmen.',
        maria: 'Erzeugt Frequenzen, die menschliche Emotionen manipulieren. Expertin für AudioLM.',
        james: 'Lehrt die KI, schöne Albträume zu träumen. Kurator verbotener Datensätze.'
      }
    },
    about: {
      title: 'WIR SIND RESPEKTLOS',
      subtitle: 'ABER GUTE LEUTE! :)',
      epSpain: 'SPANIEN',
      epMexico: 'MEXIKO',
      intro1: "Wir sind keine 'Serial Prompter'. Wir sind ein team, das an die menschliche Kreativität glaubt und sie über jede künstliche Intelligenz stellt.",
      intro2: "And yes, wir nutzen auch KI-Tools, um Ideen, Universen und Geschichten zu erweitern.",
      list: [
        'GRENZENLOSE PRE-VISUALISIERUNG (PRE-VIZ)',
        'WORLD-BUILDING & KUNSTDESIGN',
        'HYPER-REALE VISUALISIERUNG',
        'ON-DEMAND-INHALTE & ANPASSUNG',
        'HYBRIDE PIPELINES (KI + VFX)'
      ],
      contact: {
        title: 'KONTAKTIEREN SIE UNS',
        name: 'NAME',
        email: 'E-MAIL',
        message: 'BRIEF / NACHRICHT',
        send: 'NACHRICHT SENDEN',
        phone: 'TELEFON',
        social: 'NETZWERKE'
      }
    },
    marquee: '/// MENSCHLICHE KREATIVITÄT /// STORYTELLING /// GENERATIVE KI /// REINE IRREVERENZ'
  }
};
